import React, { useEffect, useState } from 'react';
import AgencyDetailsHeader from './AgencyDetailsHeader';
import AgencyInfo from './AgencyInfo';
import AgencyLog from './AgencyLog';
import {
  getAgencyDetails,
  getAgencyJobList
} from 'nursd-dashboard/api/agencyTable';
import { useParams } from 'react-router-dom';
import { useAuth } from 'nursd-dashboard/context/AuthContext';
import { Card, Col, Row } from 'react-bootstrap';

const AgencyDetails = () => {
  const { agencyId } = useParams();
  const { authToken } = useAuth();
  const [loading, setLoading] = useState(true);
  const [agency, setAgency] = useState(true);
  const [agencyJobList, setAgencyJobList] = useState([]);

  const getAgency = async id => {
    setLoading(true);
    try {
      const res = await getAgencyDetails(authToken, id);
      const resp = await getAgencyJobList(authToken, id);
      setAgency(res);
      setAgencyJobList(resp);
      setLoading(false);
    } catch (error) {
      setAgency([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (agencyId !== '') {
      getAgency(agencyId);
    }
  }, [authToken, agencyId]);

  return (
    <>
      {loading ? (
        <Card>
          <p className="m-3">Loading...</p>
        </Card>
      ) : (
        <>
          <AgencyDetailsHeader agency={agency} />
          <AgencyInfo agency={agency} />
          {agencyJobList?.length !== 0 ? (
            <AgencyLog agency={agency} agencyJobList={agencyJobList} />
          ) : (
            <Card className="mb-3">
              <Card.Header>
                <Row className="align-items-center">
                  <Col>
                    <h5 className="mb-0">Job Order List</h5>
                  </Col>
                </Row>
              </Card.Header>
              <Card.Body className="bg-body-tertiary border-top">
                <Row>
                  <Col lg xxl={5}>
                    <h6 className="fw-semibold ls mb-3 text-uppercase">
                      No Records
                    </h6>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}
        </>
      )}
    </>
  );
};

export default AgencyDetails;
